import { ServerEvent } from "@/common/notification";
import {
	SupervisorQueuesActions,
	useSupervisorQueuesStore,
} from "@/common/stores/nonpersistingStores/supervisor";
import { useAuth } from "@/hooks/authentication";
import { notificationListener } from "@/hooks/notification";
import { QueueChanged } from "@/repository/models";
import { useCallback, useEffect } from "react";
import { fetchSupervisedQueues } from "@/repository/queryFns/supervisor";

export const useSupervisorQueuesManager = () => {
	const authContext = useAuth();
	const queueActions = useSupervisorQueuesStore(
		(actions: SupervisorQueuesActions) => actions
	);

	const refreshSupervisedQueues = useCallback(() => {
		fetchSupervisedQueues().then(queueActions.setQueues);
	}, [queueActions.setQueues]);

	useEffect(() => {
		if (!authContext.isLogged) {
			return;
		}

		refreshSupervisedQueues();
	}, [authContext.isLogged]);

	notificationListener(ServerEvent.UserMembershipChanged, refreshSupervisedQueues);

	notificationListener(
		ServerEvent.UserMembershipRemoved,
		({ id }: { id: string }) => {
			queueActions.remove(id);
		}
	);

	notificationListener(ServerEvent.UserPermisionChanged, refreshSupervisedQueues);

	notificationListener<QueueChanged>(ServerEvent.QueueChanged, refreshSupervisedQueues);

	notificationListener(
		ServerEvent.QueueEstimatedWaitTimesUpdated,
		refreshSupervisedQueues
	);

	notificationListener(ServerEvent.SupervisorAgentsUpdated, refreshSupervisedQueues);
};
